import React, { type PropsWithChildren } from 'react';
import { xcss, Flex, type FlexProps } from '@atlaskit/primitives';

const Body = ({
	children,
	gap = 'space.100',
	direction = 'column',
	alignItems = 'stretch',
	justifyContent = 'center',
	testId,
}: PropsWithChildren<FlexProps>) => {
	return (
		<Flex
			xcss={bodyStyles}
			gap={gap}
			direction={direction}
			alignItems={alignItems}
			justifyContent={justifyContent}
			testId={testId}
		>
			{children}
		</Flex>
	);
};

const bodyStyles = xcss({
	gridArea: 'body',
	minWidth: '0',
});

export default Body;
